import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

type ConfirmLeaveHandler = () => Observable<boolean>;

// Bridges the tooltip admin toolbar, which is rendered outside the router
// outlet, and the route guard that asks before leaving a page with unsaved
// tooltip edits.
@Injectable({ providedIn: 'root' })
export class TooltipUnsavedChangesService {
  private confirmLeaveHandler: ConfirmLeaveHandler | null = null;

  register(handler: ConfirmLeaveHandler): void {
    this.confirmLeaveHandler = handler;
  }

  unregister(handler: ConfirmLeaveHandler): void {
    if (this.confirmLeaveHandler === handler) {
      this.confirmLeaveHandler = null;
    }
  }

  confirmLeave(): Observable<boolean> {
    return this.confirmLeaveHandler ? this.confirmLeaveHandler() : of(true);
  }
}
